// removed by extract-text-webpack-plugin
module.exports = {"container":"WLHbQ9whE4FXwUBosylOm","signature":"_2bjwIiufddZ64BdSigrX7P"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Prepare/Field/Menu/Value/Signature/styles.css
// module id = 3104
// module chunks = 0